import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(29 * 60 + 47);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => Math.max(0, t - 1)), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 bg-[var(--red-emphasis)]/10 border border-[var(--red-emphasis)]/20 rounded-lg px-3 py-2 mb-6" data-id="element-62">
      <Zap className="w-4 h-4 text-[var(--red-emphasis)] fill-current flex-shrink-0" data-id="element-63" />
      <span className="text-sm font-medium text-[var(--red-emphasis)]" data-id="element-64">
        Offer expires in:
      </span>
      <div className="flex items-center gap-1 font-mono font-bold text-[var(--red-emphasis)] text-lg" data-id="element-65">
        <span className="bg-[var(--bg-card)] px-2 py-0.5 rounded shadow-sm" data-id="element-66">
          {pad(minutes)}
        </span>
        <span className="animate-pulse" data-id="element-67">:</span>
        <span className="bg-[var(--bg-card)] px-2 py-0.5 rounded shadow-sm" data-id="element-68">
          {pad(seconds)}
        </span>
      </div>
    </div>;
}
const stackItems = [{
  label: 'Main Ebook: Sensory Feeding Victory',
  value: '$97'
}];
export function CTASection() {
  const handleBuy = () => {
    trackAddToCart();
    window.location.href = 'https://www.simplementemejor.com/cart/51799901143320:1';
  };
  return <section id="cta-section" className="py-12 md:py-20 px-4 md:px-6 bg-[var(--bg-surface)] relative overflow-hidden" data-id="element-69">
      <div className="max-w-[600px] mx-auto relative z-10" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[var(--bg-card)] border border-[var(--accent)]/20 p-6 md:p-10 rounded-2xl text-center shadow-xl" data-id="element-71">
          <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] mb-2" data-id="element-72">
            Get The Sensory Feeding Victory
          </h2>
          <p className="text-[var(--text-primary)] mb-6" data-id="element-73">
            Instant access to the complete system.
          </p>

          <CountdownTimer data-id="element-74" />

          {/* Value stack */}

          {/* Price */}
          <div className="flex flex-col items-center mb-6" data-id="element-75">
            <p className="text-sm font-bold uppercase tracking-widest text-[var(--accent)] mb-1" data-id="element-76">
              YOUR PRICE TODAY
            </p>
            <div className="text-6xl font-serif font-bold text-[var(--text-heading)]" data-id="element-77">
              $6.99
            </div>
          </div>

          {/* CTA Button */}
          <motion.button onClick={handleBuy} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full py-4 md:py-5 bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-white font-bold text-lg rounded-xl shadow-lg flex items-center justify-center gap-2 mb-6 transition-colors" data-id="element-78">
            GET ACCESS NOW FOR $6.99
          </motion.button>

          {/* Guarantee Box */}
          <div className="bg-[var(--bg-deep)] border border-[var(--accent)]/20 rounded-xl p-5 text-left" data-id="element-79">
            <div className="flex items-center gap-3 mb-3" data-id="element-80">
              <ShieldCheck className="w-8 h-8 text-[var(--trust-green)] flex-shrink-0" data-id="element-81" />
              <h3 className="font-bold text-[var(--text-heading)] text-lg" data-id="element-82">
                The "One-New-Food" Guarantee
              </h3>
            </div>
            <p className="text-sm text-[var(--text-primary)] leading-relaxed" data-id="element-83">
              Try the method for 30 full days. If your child doesn't
              successfully try at least one new food using our Texture Hacking
              protocols, just send me an email. I'll refund every penny, no
              questions asked. I'm taking 100% of the risk because I know this
              works.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}